import { useEffect } from 'react'
import { FieldValues, UseFormReset } from 'react-hook-form'
import { DEFAULT_COLOR } from 'features/rentals/rentals.config'
import { RentalItem } from 'features/rentals/types/rentals.types'

type UsePopulateRentalProps = {
	rentalData: RentalItem | undefined
	reset: UseFormReset<FieldValues>
}

export const usePopulateRental = ({ rentalData, reset }: UsePopulateRentalProps) => {
	useEffect(() => {
		if (rentalData) {
			reset({
				commission: rentalData.commission,
				price: {
					amount: rentalData.price.amount
				},
				original_price: {
					amount: rentalData.original_price.amount
				},
				is_active: rentalData.is_active,
				product_confirm_enabled: rentalData.product_confirm_enabled,
				product_import_enabled: rentalData.product_import_enabled,
				product_vat_enabled: rentalData.product_vat_enabled,
				product_supplier_sku_barcode_enabled: rentalData.product_supplier_sku_barcode_enabled,
				duration: rentalData.duration,
				currency: {
					value: rentalData.price?.currency,
					label: rentalData.price?.currency
				},
				booth_type: rentalData.booth_type
					? {
							value: rentalData.booth_type,
							label: rentalData.booth_type_name?.name
						}
					: null,
				title: rentalData.title,
				description: rentalData.description,
				color: rentalData.color || DEFAULT_COLOR
			})
		}
	}, [rentalData])
}
